import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inventories-dashboard',
  templateUrl: './inventories-dashboard.component.html',
  styleUrls: ['./inventories-dashboard.component.scss']
})
export class InventoriesDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
